<div class="mobile-verify-otp">
  <div class="vo-status-spacer"></div>

  <button type="button" class="vo-back-btn" (click)="navigateBack()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <h1>{{ 'VERIFY_OTP.TITLE' | translate }}</h1>
  <p class="vo-subtitle">{{ 'VERIFY_OTP.SUBTITLE' | translate }} <strong>{{ email }}</strong></p>

  <div class="vo-otp-row">
    <input
      #otpInput
      *ngFor="let value of otpValues; let i = index"
      class="vo-otp-box"
      [class.vo-otp-box--error]="otpError || requestError"
      [class.vo-otp-box--shake]="isOtpShaking"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      [(ngModel)]="otpValues[i]"
      (input)="onOtpInput($event, i)"
      (keydown)="onOtpKeydown($event, i)"
      (paste)="onOtpPaste($event)"
    />
  </div>

  <span *ngIf="otpError" class="vo-otp-error">{{ otpError | translate }}</span>
  <p class="vo-request-error" *ngIf="requestError">{{ requestError | translate }}</p>
  <p class="vo-success-msg" *ngIf="successMessage">{{ successMessage | translate }}</p>

  <button type="button" class="vo-send-btn" (click)="validateAndSubmit()" [disabled]="isLoading">
    <span *ngIf="!isLoading">{{ 'VERIFY_OTP.SEND_BTN' | translate }}</span>
    <i *ngIf="isLoading" class="bi bi-arrow-repeat vo-spinner"></i>
  </button>

  <p class="vo-resend">
    <span class="vo-resend-text">{{ 'VERIFY_OTP.DIDNT_GET_CODE' | translate }}</span>
    <span *ngIf="!canResend" class="vo-resend-countdown">
      {{ 'VERIFY_OTP.RESEND_IN' | translate }} {{ resendCountdown | number:'2.0-0' }}s
    </span>
    <span *ngIf="canResend" class="vo-resend-link" (click)="resendCode()" [class.vo-resend-disabled]="isResending">
      {{ 'VERIFY_OTP.RESEND_LINK' | translate }}
    </span>
  </p>

  <div class="vo-home-indicator-spacer"></div>
</div>
